import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CookieCiencuadras } from '../../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { environment } from '@env/environment';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ProductsService } from 'src/app/services/products/products.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-warning-message-modal',
  templateUrl: './warning-message-modal.component.html',
  styleUrls: ['./warning-message-modal.component.scss']
})
export class WarningMessageModalComponent implements OnInit {

  urlPublicaTuMismo: string = environment.urlPublishYourself;
  urlSelectionIdeal: string = '/productos/seleccion-ideal';
  clientType: string = "";
  idClientType: string = '';
  subscriptionBackdrop$!: Subscription;
  subscriptionOpen$!: Subscription;
  subscriptionClosed$!: Subscription;
  disableClose: boolean = true;
  isValue: number = 0;
  isAgent: boolean = false;
  isPerson: boolean = false;
  logo = `${environment.environmenturl}sources/images/result/isotipo.png`;
  textMessageModalAgent: string = 'Estás intentando comprar un plan para agente inmobiliario desde un usuario de propietario. ¿Deseas cambiar tu tipo de usuario a agente inmobiliario?';
  textMessageModal: string = 'Estas intentando adquirir un plan que no está asociado a tu tipo de usuario, serás dirigido a los planes que tenemos disponibles para ti.';
  
  @Output() outBackdrop = new EventEmitter();

  constructor(
    public cookieCiencuadras: CookieCiencuadras,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<WarningMessageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data:string,
    public http: HttpClient,
    private productsService: ProductsService,
    private router: Router,
  ) {
    this.modalControl();
  }

  ngOnInit(): void {
    this.setClientType();
    this.idClientType = this.cookieCiencuadras.getCookie('idClientType');    
  }

  setClientType() {
    switch (this.cookieCiencuadras.getCookie('typeUser')) {
      case "Inmobiliaria":
        this.clientType = "1";
        break;
      case "Agente independiente":
        this.clientType = "2";
        break;
      case "Constructora":
        this.clientType = "3";
        break;
      case "Persona Natural":
        this.clientType = "4";
        break;
      default:
        this.clientType = "";
        break;
    }
    this.cookieCiencuadras.setCookie('clientType', this.clientType);
    localStorage.setItem('clientType', this.clientType);
  }

  close(): void {
    if (this.dialogRef && !this.disableClose) {
      this.clean(this.dialogRef);
    }
  }

  clean(dialogRef: MatDialogRef<any>) {
    this.subscriptionOpen$?.unsubscribe();
    this.subscriptionBackdrop$?.unsubscribe();
    dialogRef.close();
    this.dialog.closeAll();
    this.subscriptionClosed$?.unsubscribe();
  }

  modalControl() {
    this.isValue = parseInt(localStorage.getItem('clientType'));
    if(this.cookieCiencuadras.getCookie('typeUser') === "Agente independiente"){
      this.isAgent = true;
    }
    if(this.cookieCiencuadras.getCookie('typeUser') === "Persona Natural"){
      this.isPerson = true;
    }
  }

  userTypeChange(): void {
    this.productsService.userTypeChange().subscribe(
      (res) => {
        console.log("userTypeChangeButton response: ", res);
        window.location.href = '/productos/seleccion-ideal';
      },
      (error) => {
        console.log("userTypeChangeButton error: ", error);
        if(error.status === 200){
          console.log("userTypeChangeButton error: ", error.status);
          this.cookieCiencuadras.setCookie('clientType', '2');
          setTimeout(() =>
          (window.location.href = '/productos/seleccion-ideal'), 1000
        );
        }
        else{
          window.location.href = '/productos';
        }
      }
    );
 }
}
